<template>
  <div class="flex w-full justify-between text-2xl">
    <span class="font-semibold">
      {{ $t('general.price_total.total') }}
    </span>
    <span class="flex items-center justify-end gap-3">
      <span
        v-if="recommendPrice > 0"
        id="recommended-price"
        class="font-semibold text-gray-lighter line-through"
      >
        {{ formatPrice(recommendPrice) }}
      </span>
      <span id="price" class="font-bold">
        {{ formatPrice(currentPrice) }}
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { usePriceFormatter } from '@/composables/UsePriceFormatter';
import { useSizeStore } from '@/stores/Configurator/SizeStore.js';
import { computed } from 'vue';

const sizeStore = useSizeStore();

const { formatPrice } = usePriceFormatter();

const recommendPrice = computed(
  () => sizeStore.selectedSizeValue.attributes.recommendedPrice / 100
);
const currentPrice = computed(
  () => sizeStore.selectedSizeValue.attributes.price / 100
);
</script>
